import { useMemo } from 'react'

import { aqsiMySession } from '@krp/resource-aqsi-ui'

import { useAppSelector } from '../../app/hooks'
import { useRefetchOnReconnect } from '../../app/connection'

/**
 * Моя работа за кассой этого источника — из НАШЕЙ базы (`sessions/mine`), кабинет не нужен: идущая продажа и
 * возврат видны, даже когда кабинет не ответил на список касс (UI-RMK-FLOW 3.1). `session`: `undefined` —
 * ещё не прочитано, `null` — работа не начата.
 */
export function useMySession(resourceId: string) {
  const args = useMemo(() => ({ resourceId }), [resourceId])
  const subscription = aqsiMySession.useQuerySubscription(args, { skip: resourceId === '' })
  const select = useMemo(() => aqsiMySession.select(args), [args])
  const result = useAppSelector(select)
  // Сбой связи показывает общее окно приложения; после восстановления связи моя работа перечитывается.
  useRefetchOnReconnect(subscription.refetch, resourceId !== '')
  return { result, select, session: result.data }
}
